import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { store } from "./api/store/store";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./authConfig";
import { setMsalInstance } from "./services/msalService";

import "./index.scss";
import "./services/i18n";

const msalInstance = new PublicClientApplication(msalConfig);

// MSAL Browser v3 onwards, initialize() must be called and awaited before calling any MSAL API
// thus, using this bootstrapping mechanism before rendering react app
async function bootstrap() {
  await msalInstance.initialize();
  setMsalInstance(msalInstance);

  const root = ReactDOM.createRoot(
    document.getElementById("root") as HTMLElement
  );

  root.render(
    // <React.StrictMode>
    <MsalProvider instance={msalInstance}>
      <Provider store={store}>
        <App />
      </Provider>
    </MsalProvider>
    // </React.StrictMode>
  );
}

// execute bootstrap
bootstrap();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
